import { render } from "./Register.vue?vue&type=template&id=ea3c6a30"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\noklo\\Documents\\GitHub\\NontCO2\\NontRegister-market\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__